module.exports = __webpack_public_path__ + "static/img/C4D0008.0ef0c25.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/intru/C4D0008.jpg
// module id = KAjY
// module chunks = 0